import { Navigate } from 'react-router-dom'
import { hasValidAccessToken } from '@/lib/api'
import { ROUTES } from '@/lib/constants'

/**
 * Wrapper que redirige a /login si no hay JWT válido en memoria.
 * Sin retry — si el token expiró, el interceptor del api.ts ya
 * limpió el storage.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (!hasValidAccessToken()) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }
  return <>{children}</>
}
